import Vue from 'vue'
import Waiting from './waiting.vue'

const instance = new Vue({
  render (h) {
    return h(Waiting)
  }
}).$mount()

document.body.appendChild(instance.$el)
const component = instance.$children[0]

export default {
  show () {
    component.show()
  },

  hidden () {
    component.hidden()
  }
}
